import React, { Component } from "react";
import { switchReportStyle } from "../../Timps/Switch/style/index";
import { themeService } from "../../../../theme/service/activeTheme.service";
import _ from "lodash";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import ReportFraInfoSectionContainer from "../../../../libraries/ReportGenerator/ReportFraInfoSection";
import ReportFraConditionsMasterKey from "../../../../libraries/ReportGenerator/ReportFraConditionsMasterKey";
import { ReportGroupingUtils } from "../../utils/reportGroupingUtils";
import { ONR_GenericTestsReportSchema } from "./ONR_GenericTestsReportSchema";

const masterKey = [
  { key: "OK", value: "Test complete equipment in satisfactory condition." },
  { key: "A/C", value: "Adjustments made/test complete-equipment in satisfactory condition." },
  { key: "R/C", value: "Repair or replacement/test complete-equipment in satisfactory condition." },
  { key: "N/A", value: "Test Not Applicable." },
  { key: "", value: "If results are 'A/C' or 'R/C' explain the procedure in the comments column." },
];

const ReportView = (props) => {
  let { data } = props;

  return (
    <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
      <ReportTitleSection title="Generic Tests" {...props} fontSizeOverride={"35px"} centerTitle={true} />
      <span className="spacer"></span>
      <ReportFraInfoSectionContainer {...props} />
      <ReportFraConditionsMasterKey masterKey={masterKey} />
      <span className="spacer"></span>
      <table className="table-bordered" style={{ fontSize: "20px" }}>
        {ONR_GenericTestsReportSchema.sections.map((section) => {
          return <ReportTableSectionRenderer section={section} rowsData={data.decodedData} />;
        })}
      </table>
    </div>
  );
};

const ONR_GenericTestsReport = (props) => {
  const { reportData } = props;
  let reportsByDateAndUser = ReportGroupingUtils.groupReportsByDateAndUser(reportData);
  let reportGroups = ReportGroupingUtils.filterReportsByTestCodes(reportsByDateAndUser, ["TC_Generic"]);
  let reportsWithDecodedFormData = ReportGroupingUtils.decodeTestsInReportGroups(reportGroups);

  return reportsWithDecodedFormData.map((report) => <ReportView {...props} data={report} />);
};

export default ONR_GenericTestsReport;



// WEBPACK FOOTER //
// ./src/components/Reports/ONR/GenericTestsReport/index.jsx